var render, staticRenderFns
import script from "./InfinityLoader.vue?vue&type=script&lang=js&"
export * from "./InfinityLoader.vue?vue&type=script&lang=js&"
import style0 from "./InfinityLoader.vue?vue&type=style&index=0&id=750246b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750246b1",
  null
  
)

export default component.exports